export const types = {
  CONTACT_FORM_SUBMIT: 'CONTACT_FORM_SUBMIT',
  SET_ACTIVE_SECTION: 'SET_ACTIVE_SECTION',
  SET_AUTO_SLIDE: 'SET_AUTO_SLIDE',
  SET_FIX_NAV: 'SET_FIX_NAV',
  SET_INACTIVE_SLIDE: 'SET_INACTIVE_SLIDE',
  SET_MENU: 'SET_MENU',
  SET_SLIDE: 'SET_SLIDE'
}